import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlanningFormStatus } from '../models/planning-form-status';

// This service is provided in app.module.ts
// due to use in modal component
@Injectable()

export class PlanningFormService {
  private formStatusSubject = new BehaviorSubject<PlanningFormStatus | any>({});

  getCurrentFormStatus() {
    return this.formStatusSubject.getValue();
  }

  getFormStatusObservable() {
    return this.formStatusSubject.asObservable();
  }

  setFormStatus(formName: string, status: boolean) {
    const currentForm = this.formStatusSubject.getValue();
    currentForm[formName] = status;
    this.updateFormStatus(currentForm);
  }

  updateFormStatus(form) {
    if (!form) {
      form = this.createNewForm();
    } else if (form && form.transactionAndTestedPartyForm && form.financialDetialsForm && form.taxRateForm && form.riskSettingsForm) {
      form.projectionReady = true;
    } else {
      form.projectionReady = false;
    }
    this.formStatusSubject.next(form);
  }

  createNewForm() {
    return new PlanningFormStatus();
  }
}
